import { inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from './google-analytics.service';
import { MixPanelAnalyticsService } from './mixpanel-service';
import { LoginResp } from '../../models/Login';



@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  googleAnalytics = inject(GoogleAnalyticsService)
  mixPanelAnalytics = inject(MixPanelAnalyticsService)

  logPage(url: string) {
    this.googleAnalytics.logPage(url);
    this.mixPanelAnalytics.logPage(url);
  }


  logEvent(eventName: string, params: any = {}) {
    this.googleAnalytics.logEvent(eventName, params);
    this.mixPanelAnalytics.logEvent(eventName, params);
  }

  setUser(sessionId: string, properties: LoginResp) {
    this.googleAnalytics.setUserProperties(sessionId, properties);
    this.mixPanelAnalytics.setUserProperties(sessionId, properties);
  }
}
